import "@styles/layout.css";
import { Outlet, useLocation } from "react-router-dom";

import Footer from "@common-components/Footer/Footer";
import NotifyPop from "@common-components/NotifyPop/NotifyPop";
import NavbarPlaceholder from "@common-components/NavbarPlaceholder/NavbarPlaceholder";
import GeneralNavbar from "@common-components/GeneralNavbar/GeneralNavbar";

const PageLayout = () => {
  const location = useLocation();

  return (
    <div className="Layout__container">
      {location.pathname === "/home/login" ? null : <GeneralNavbar />}
      <Outlet />
      <Footer />
      <NotifyPop />
    </div>
  );
};
export default PageLayout;
